export const ROUTES = {
  HOME: '/',
  AUTH: '/auth',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  PROFILE: '/profile',
  COURSES: '/courses',
  FAVORITES: '/favorites',
  SUBSCRIBE: '/subscribe',
  WC: '/wc',
  WEDDING_COURSE_V2: '/weddingcourse',
  CARD: (cardId: string | number = ':cardId') => `/card/${cardId}`,
  COURSE_DETAIL: (courseId: string | number = ':courseId') => `/courses/${courseId}`,
  LESSON: (courseId: string | number = ':courseId', lessonId: string | number = ':lessonId') =>
    `/courses/${courseId}/lesson/${lessonId}`,
  CALCULATOR: (cardId: string | number = ':cardId?') => `/calculator/${cardId}`,
  LINK_TELEGRAM_CONFIRM: '/link-telegram/confirm',
  TELEGRAM_AUTH_CONFIRM: '/telegram-auth/confirm'
} as const

// Свадебный курс — единственный курс с grant_type='buy', публикуется по короткой ссылке /wc.
export const WEDDING_COURSE_ID = 1

// Оплата свадебного курса временно идёт через отдельного Telegram-бота
// (не через web-флоу). Та же ссылка использовалась до перехода на оплату картой.
export const WEDDING_BOT_PAYMENT_URL =
  'https://telegram.me/pauline_wedding_bot?start=link_a1vInKgosx'

// Отмена подписки Tribute: их автосписаниями наш бэк не управляет, поэтому
// после сбора причины уводим пользователя в сценарий отмены в нашем боте.
// cmd_run_<id> — идентификатор сценария puzzlebot, общий для всех пользователей.
/** Основной бот: выдаёт доступ по подписке, через него же идёт поддержка. */
export const SECRET_BOT_URL = 'https://t.me/pauline_secret_bot'

const TRIBUTE_CANCEL_BOT = 'pauline_secret_bot'
const TRIBUTE_CANCEL_START = 'cmd_run_1993582663'

/** Для Telegram: openTelegramLink принимает только t.me и закрывает мини-апп. */
export const TRIBUTE_CANCEL_BOT_URL = `https://t.me/${TRIBUTE_CANCEL_BOT}?start=${TRIBUTE_CANCEL_START}`

/**
 * Для веба: сразу в Telegram Web, чтобы не упереться в «приложение не
 * установлено». Схема tgaddr — то, что Telegram сам подставляет в свою кнопку
 * «Open in Web»; она доносит до бота start-параметр, который при обычной
 * ссылке t.me терялся бы при установке клиента. Значение кодируем, иначе
 * `&start=` разберётся как отдельный параметр адреса, а не часть tgaddr.
 */
export const TRIBUTE_CANCEL_BOT_WEB_URL = `https://web.telegram.org/k/#?tgaddr=${encodeURIComponent(
  `tg://resolve?domain=${TRIBUTE_CANCEL_BOT}&start=${TRIBUTE_CANCEL_START}`
)}`
